// extracted by mini-css-extract-plugin
export default {"shadowed":"Navigation_shadowed__cRDf5","active":"Navigation_active__8X7xS"};